function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTestsCategories = function SvgTestsCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tests-categories_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2 15.5h29.6v24.9H13.2z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    style: {
      fill: "#daebdb",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#tests-categories_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2 24.3h8.9c1.7 0 3.1 1.1 3.6 2.7.5 2-.6 4-2.6 4.5-.2.1-.4.1-.6.1-1.2.1-7 0-8.2 0h-5.4c-2 0-3.7-1.6-3.7-3.6s1.4-3.6 3.4-3.7zm0 5.8h8.7c.4 0 .7-.1 1.1-.2 1.1-.5 1.5-1.8 1-2.8-.3-.7-1-1.2-1.8-1.2H25.9c-.6 0-1.2.2-1.7.7-.6.6-.8 1.5-.4 2.2.3.8 1 1.4 1.9 1.4 1.5 0 3-.1 4.5-.1M30.2 22.9h-4.3c-2 0-3.7-1.6-3.8-3.6 0-.3 0-.5.1-.8.3-1.7 1.8-2.9 3.5-3h13.5c2 .1 3.6 1.8 3.6 3.8-.1 2-1.7 3.6-3.6 3.6-1.5.1-7.5 0-9 0m0-1.5h8.9c1.2 0 2.1-1 2.1-2.1 0-1.2-1-2.1-2.1-2.1H25.9c-.4 0-.7.1-1.1.3-.9.5-1.3 1.4-1 2.4.2.9 1.1 1.6 2 1.6 1.5-.1 3-.1 4.4-.1M30.2 40.5h-4.3c-2 0-3.7-1.6-3.8-3.6 0-1.7 1.1-3.2 2.7-3.6.3-.1.6-.1.9-.1h13.4c2 .1 3.6 1.8 3.5 3.9-.1 1.9-1.6 3.4-3.5 3.5-1.4-.1-7.4-.1-8.9-.1m.1-5.9h-4.4c-1.2 0-2.2.9-2.2 2.1s.9 2.2 2.1 2.2H39c.3 0 .5 0 .8-.1 1.1-.4 1.7-1.6 1.3-2.7-.3-.8-1.1-1.4-2-1.4-1.4-.1-7.4-.1-8.8-.1M16.9 15.5c2 0 3.7 1.6 3.7 3.7s-1.6 3.7-3.7 3.7-3.7-1.6-3.7-3.7c0-2 1.7-3.7 3.7-3.7m2.1 3.7c0-1.2-1-2.1-2.2-2.1s-2.1 1-2.1 2.2 1 2.1 2.1 2.1c1.3 0 2.2-1 2.2-2.2M20.6 36.8c0 2-1.7 3.7-3.7 3.7s-3.7-1.7-3.7-3.7 1.7-3.7 3.7-3.7 3.7 1.6 3.7 3.7m-1.6 0c0-1.2-1-2.1-2.1-2.1-1.2 0-2.1 1-2.1 2.1 0 1.2 1 2.1 2.1 2.1 1.2 0 2.1-1 2.1-2.1M16.9 31.7c-2 0-3.7-1.6-3.7-3.7s1.6-3.7 3.7-3.7 3.7 1.6 3.7 3.7c0 2-1.6 3.7-3.7 3.7m0-1.6c1.2 0 2.1-1 2.1-2.1 0-1.2-1-2.1-2.1-2.1-1.2 0-2.1 1-2.1 2.1 0 1.2.9 2.1 2.1 2.1",
    style: {
      fill: "#074f4f",
      strokeWidth: 0
    }
  })));
};
export default SvgTestsCategories;